"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocale = void 0;
const react_intl_1 = require("react-intl");
function useLocale() {
    const intl = (0, react_intl_1.useIntl)();
    return intl.locale;
}
exports.useLocale = useLocale;
//# sourceMappingURL=use-locale.js.map